import {computed, inject, Injectable} from '@angular/core';
import {rxResource, toSignal} from '@angular/core/rxjs-interop';
import {TranslocoService} from '@jsverse/transloco';
import {DirectusService, Tooltip} from '@frontend/directus';
import {PROVIDER_STATUS_TOOLTIP_KEY_PREFIX} from './provider-status-table.types';

@Injectable()
export class ProviderStatusLookupService {
  private readonly directusService = inject(DirectusService);
  private readonly transloco = inject(TranslocoService);

  private readonly currentLang = toSignal(this.transloco.langChanges$, {
    initialValue: this.transloco.getActiveLang(),
  });

  private readonly hrToolsResource = rxResource({
    stream: () => this.directusService.loadHrToolsMini(),
  });

  private readonly statusTooltipsResource = rxResource({
    stream: () => this.directusService.loadTooltipsByKeyPrefix(PROVIDER_STATUS_TOOLTIP_KEY_PREFIX),
  });

  readonly isLoading = computed(
    () => this.hrToolsResource.isLoading() || this.statusTooltipsResource.isLoading(),
  );

  readonly providerNamesByUuid = computed<Map<string, string>>(
    () =>
      new Map(
        (this.hrToolsResource.value() ?? []).map((hrTool) => [
          hrTool.id,
          hrTool.toolProvider?.name ?? '',
        ]),
      ),
  );

  readonly statusTooltipTextsByKey = computed<Map<string, string>>(() => {
    const language = this.currentLang();
    return new Map(
      (this.statusTooltipsResource.value() ?? []).map((tooltip: Tooltip) => [
        tooltip.key,
        tooltip.translations.find((translation) => translation.language === language)
          ?.tooltipText ??
          tooltip.translations[0]?.tooltipText ??
          '',
      ]),
    );
  });
}
